import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    SET_INIT_USER: 'SET_INIT_USER',
    SET_HUB_INFO: 'SET_HUB_INFO',
    SET_BAROMONEY: 'SET_BAROMONEY',
    SET_BAROMONEY_HISTORY: 'SET_BAROMONEY_HISTORY',
    SET_USER_INFO: 'SET_USER_INFO',
    SET_PERMISSION: 'SET_PERMISSION',
};
export const userMutationType = vuexEventPathGenerator(mutationType, 'user');
const mutations = {
    [mutationType.SET_INIT_USER]: (state, initUser) => { state.initUser = initUser; },
    [mutationType.SET_HUB_INFO]: (state, hubInfo) => { state.hubInfo = hubInfo; },
    [mutationType.SET_BAROMONEY]: (state, baromoney) => {
        state.baromoney = {
            ...state.baromoney,
            ...baromoney,
        };
    },
    [mutationType.SET_BAROMONEY_HISTORY]: (state, baromoneyHistory) => {
        state.baromoney = {
            ...state.baromoney,
            ...baromoneyHistory,
        };
    },
    [mutationType.SET_USER_INFO]: (state, userInfo) => { state.userInfo = userInfo; },
    [mutationType.SET_PERMISSION]: (state, userPermission) => { state.userPermission = userPermission; },
};
export default mutations;
